var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},[_vm._v("\n  "+_vm._s(_vm.params.data.sets.length)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }